import { useMediaQuery } from 'react-responsive';
import MobileRegister from './MobileRegister';
import Register from './Register';

const RegisterRouter = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 }); // adjust breakpoint if needed

  return isMobile ? <MobileRegister /> : <Register />;
};

export default RegisterRouter;
